<template>
  <div class="w-full">
    <DatatableReportV3
      title="Timesheets"
      :source="source"
      :config="config"
      :filters="filters"
      download-url="/reports/time_cards"
      flat
    >
      <template #actions>
        <sera-button
          icon="plus"
          label="Create New"
          @click="toggleOpen"
        ></sera-button>
      </template>
      <template #column-actions="rowData">
        <TimeCardActionsMenu :time-card="parseRowData(rowData.actions)" />
      </template>
    </DatatableReportV3>
    <TimeCardModal v-if="open" @close="toggleOpen" />
  </div>
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TimeCardActionsMenu from "./TimeCardActionsMenu.vue";
import TimeCardModal from "./TimeCardModal.vue";

export default {
  components: {
    DatatableReportV3,
    TimeCardActionsMenu,
    TimeCardModal
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false,
      config: {
        responsive: true,
        order: [3, "desc"],
        columns: [
          {
            data: "employee",
            searchable: false,
            orderable: false,
            aggregateTitle: "Total Employees",
            responsivePriority: 1
          },
          { data: "role", searchable: false, responsivePriority: 5 },
          {
            data: "email",
            searchable: false,
            orderable: false,
            responsivePriority: 6
          },
          {
            data: "start_time",
            title: "Start Time",
            searchable: false,
            responsivePriority: 2
          },
          {
            data: "end_time",
            title: "End Time",
            searchable: false,
            responsivePriority: 4
          },
          { data: "duration", searchable: false, responsivePriority: 3 },
          {
            data: "last_edited",
            title: "Last Edited",
            searchable: false,
            responsivePriority: 7
          },
          { data: "actions", title: "", searchable: false, orderable: false }
        ]
      }
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    parseRowData(data) {
      // Parse json string
      try {
        return JSON.parse(data.replace(/&quot;/gi, '"'));
      } catch (e) {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
